// ニュース詳細で使用するモーダル
$(function(){
  jsModal();
});

var jsModal = function() {
  if($('.js-modal').length){
    var oriHash = [];
    var top = 0;

    $('.js-modal').on('click', function(e){
      e.preventDefault();
      var $this = $(this);
      var target = $this.attr('href');
      var hash = window.location.hash;

      if($(target).length > 0) {
        top = $(window).scrollTop();

        if(hash) {
          oriHash.push(hash);
        }

        $(target).fadeIn(250);
        $('html').css({
          'position': 'fixed',
          'top': top * -1,
          'left': 0,
          'width': '100%'
        });
      }
    });

    $('.mod-modal-01 .btn-close-top, .mod-modal-01 .btn-close-bottom, .modal-shadow').on('click', function(){
      closeModal();
    });

    function closeModal(){
      $('.mod-modal-01').fadeOut(250);
      $('html').removeAttr('style');
      $(window).scrollTop(top);
    }
  }
};